import React from 'react';
import { format, utcFormat } from 'd3'
import { translate } from './translate';
import { DATE, VOLUME } from './constants';
import './MarketValues.css'

const volumeFormat = format(',r')

function PerformanceValues (props) {
  const dateFormat = utcFormat('%x')
  const { datum, valueFormat, shouldLabelAsOf, i18n, lang, hideVolume } = props
  return (
    <ul className='MarketValues'>
      <li>{shouldLabelAsOf ? <label>{translate('AS_OF', i18n, lang)}</label> : null}{dateFormat(datum[DATE])}</li>
      <li><label>{translate('CLOSE',  i18n, lang)}</label>{format(valueFormat)(datum['yValues'][0])}</li>
      {hideVolume ? null : <li><label>{translate('VOLUME', i18n, lang)}</label>{volumeFormat(datum[VOLUME])}</li>}
    </ul>
  )
}

function PremiumDiscountValues (props) {  
  const dateFormat = utcFormat('%x')
  const { datum, valueFormat, shouldLabelAsOf, valueProp, summaries, i18n, lang } = props
  const value = datum[valueProp]
  const formatter = format(valueFormat)
  return (
    <ul className='MarketValues'>
      <li>{shouldLabelAsOf ? <label>{translate('AS_OF', i18n, lang)}</label> : null}{dateFormat(datum[DATE])}</li>
      <li><label>{translate(value >= 0 ? 'PREMIUM' : 'DISCOUNT', i18n, lang)}</label>{formatter(value)}</li>
      {
        summaries.map(({label,value}, i) => (
          <li key={i}><label>{label}</label>{formatter(value)}</li>
        ))
      }
    </ul>
  )
}

export { PerformanceValues, PremiumDiscountValues }


// WEBPACK FOOTER //
// ./src/MarketValues.js